import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../application/config/config';
import { useMemo } from 'react';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/secretariats/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: `${config.endpoints.backend}governanceroom/secretariats/getall`,
        endpointDelete: `${config.endpoints.backend}governanceroom/secretariats/delete`,
    }

    const list = useMemo(() => ({
        labelTitle: 'Secretarias',
        filter:{
            ...profileFilter
        },
        labelTitleButtonAdd: 'Nova secretaria',
        fieldsShowOnDelete: ['title_secretariat'],
        showPrintButtons: false,
        canDelete: true,
        canEdit: true,
        columns: [
            {
                name: 'client_name',
                label: 'Cliente',
                width: '30%'
            },
            {
                name: 'geo_city_name',
                label: 'Município',
                width: '30%'
            },
            {
                name: 'title_secretariat',
                label: 'Secretaria',
                width: '30%'
            },
        ],
        ...paths
    }), []);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list]);

    const customListContainer = useMemo(() => (
    <CustomListContainer
        pathAdd={paths.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={content}
    />
    ), [content, list.labelTitle, list.labelTitleButtonAdd, paths.pathAdd]);
    
    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;